var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.loaderFullContainer ? 'h-full' : 'loader'},[_c('div',{staticClass:"flex pt-2 items-center justify-center h-full"},[_c('div',{staticClass:"spinner-grow text-gray-600",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }